import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ShiftsComponent } from './shifts.component';
import { ShiftDetailsComponent } from './components/shift-details/shift-details.component';
import { ShiftViewComponent } from './components/shift-view/shift-view.component';

const routes: Routes = [
  {
    path: '', component:ShiftsComponent,children:[
       {
         path:'',component: ShiftDetailsComponent
       },
       {
        path:'details',component: ShiftDetailsComponent
       },
       {
         path: 'view/:id', component: ShiftViewComponent
       } 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShiftsRoutingModule { }
